<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 2000 112.67"
		id="top-ridge"
		:class="fillClass"
	>
		<title>top-ridge</title>
		<g id="Layer_2" data-name="Layer 2">
			<g id="Layer_1-2" data-name="Layer 1">
				<path
					class="cls-1"
					d="M0,3.67c5-4.89,15-4.89,20,0s15,4.88,20,0,15-4.89,20,0,15,4.88,20,0,15-4.89,20,0,15,4.88,20,0,15-4.89,20,0,15,4.88,20,0,15-4.89,20,0,15,4.88,20,0,15-4.89,20,0,15,4.88,20,0,15-4.89,20,0,15,4.88,20,0,15-4.89,20,0,15,4.88,20,0,15-4.89,20,0,15,4.88,20,0,15-4.89,20,0,15,4.88,20,0,15-4.89,20,0,15,4.88,20,0,15-4.89,20,0,15,4.88,20,0,15-4.89,20,0,15,4.88,20,0,15-4.89,20,0,15,4.88,20,0,15-4.89,20,0,15,4.88,20,0,15-4.89,20,0,15,4.88,20,0,15-4.89,20,0,15,4.88,20,0,15-4.89,20,0,15,4.88,20,0,15-4.89,20,0,15,4.88,20,0,15-4.89,20,0,15,4.88,20,0,15-4.89,20,0,15,4.88,20,0,15-4.89,20,0,15,4.88,20,0,15-4.89,20,0,15,4.88,20,0,15-4.89,20,0,15,4.88,20,0,15-4.89,20,0,15,4.88,20,0,15-4.89,20,0,15,4.88,20,0,15-4.89,20,0,15,4.88,20,0,15-4.89,20,0,15,4.88,20,0,15-4.89,20,0,15,4.88,20,0,15-4.89,20,0,15,4.88,20,0,15-4.89,20,0,15,4.88,20,0,15-4.89,20,0,15,4.88,20,0,15-4.89,20,0,15,4.88,20,0,15-4.89,20,0,15,4.88,20,0,15-4.89,20,0,15,4.88,20,0,15-4.89,20,0,15,4.88,20,0,15-4.89,20,0,15,4.88,20,0,15-4.89,20,0,15,4.88,20,0,15-4.89,20,0,15,4.88,20,0,15-4.89,20,0,15,4.88,20,0,15-4.89,20,0,15,4.88,20,0,15-4.89,20,0,15,4.88,20,0,15-4.89,20,0,15,4.88,20,0,15-4.89,20,0,15,4.88,20,0,15-4.89,20,0,15,4.88,20,0,15-4.89,20,0,15,4.88,20,0,15-4.89,20,0,15,4.88,20,0,15-4.89,20,0,15,4.88,20,0,15-4.89,20,0,15,4.88,20,0,15-4.89,20,0,15,4.88,20,0v109H.5Z"
				/>
			</g>
		</g>
	</svg>
</template>

<script>
	export default {
		name: "TopRidge",
		props: ["fillClass"]
	};
</script>

<style lang="scss" scoped>
	#top-ridge {
		position: absolute;
		top: -21%;
		left: 0;
	}

	@media (min-width: $breakpoint-small) {
		#top-ridge {
			top: -31%;
		}
	}

	.maroon {
		.cls-1 {
			fill: $maroon;
		}
	}
	.teal {
		.cls-1 {
			fill: $teal;
		}
	}

	.gold {
		.cls-1 {
			fill: $gold;
		}
	}
</style>
